import { AsyncPipe } from '@angular/common';
import { Component, OnInit, ChangeDetectionStrategy, output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { PopoverModule } from 'primeng/popover';
import { BehaviorSubject, Observable } from 'rxjs';

@Component({
  selector: 'settlement-actions',
  standalone: true,
  imports: [ButtonModule, PopoverModule, TranslateModule, AsyncPipe],
  templateUrl: './settlement-actions.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SettlementActionsComponent implements OnInit {
  columnData: Observable<any> = new BehaviorSubject(null);
  additionData: Observable<any> = new BehaviorSubject(null); // expected data ["edit","active","inactive"] etc
  rowIndex: number = 0;

  readonly onAction = output<{ action: string; columnData: any; rowIndex: number; }>(); // {type:actionName,columnData }
  showOptions = false;
  currentUserDetails: any;
  showSalesReturn=  new BehaviorSubject(false);
  showRefund= new BehaviorSubject(false);

  constructor() { }

  ngOnInit(): void {
  }

  executeAction(action: string, columnData: any, overlayElement: any) {
    //overlayElement.hide();
    this.onAction.emit({ action, columnData: columnData, rowIndex: this.rowIndex });
  }

}

